
import axios from "axios";
import { RefundPolicyUrl, PrivacyPolicyUrl, CancellationPolicyUrl, TNCUrl } from "../url/index";

export const RefundPolicyAction = async () => {
  try {
    const { data } = await axios.get(RefundPolicyUrl);
    return data;
  } catch (err) {
    throw err;
  }
};

export const PrivacyPolicyAction = async () => {
  try {
    const { data } = await axios.get(PrivacyPolicyUrl);
    return data;
  } catch (err) {
    throw err;
  }
};

export const CancellationPolicyAction = async () => {
  try {
    const { data } = await axios.get(CancellationPolicyUrl);
    return data;
  } catch (err) {
    throw err;
  }
};

export const TermConditionsAction = async () => {
  try {
    const { data } = await axios.get(TNCUrl);
    return data;
  } catch (err) {
    throw err;
  }
};